<template>
  <div id="user">
    <p class="title">
      <label @click="$router.push('/user/home')">我的 / </label>
      收货地址管理</p>
    <div class="common-search-box">
      <button class="common-btn" @click="addressModal = true; editFlag = false">新增收货地址</button>
    </div>
    <div class="table">
      <el-card v-for="(item,i) in addressList" :key="i">
        <p>
          <span style="font-size:32px; color:#ff8000">{{item.receiverName}}</span>
          <span style="color:green" v-if="item.isDefault == 0">  (默认地址)</span>
        </p>
        <p>
          <span>收货人：</span>
          <span>{{item.receiverName}}</span>
        </p>
        <p>
          <span>所在地区：</span>
          <span>{{item.receiverProvince+item.receiverCity+item.receiverDistrict}}</span>
        </p>
        <p>
          <span>地址：</span>
          <span>{{item.receiverAddress}}</span>
        </p>
        <p>
          <span>手机：</span>
          <span>{{item.receiverPhone}}</span>
        </p>
        <div class="btn-box">
          <button v-if="item.isDefault != 0" class="common-btn-text common-btn-text-1" @click="modifyDefaultAddress(item)">设为默认</button>
          <button
            class="common-btn-text common-btn-text-2"
            @click="addressData = item;addressModal = true; editFlag = true"
            style="margin-left:10px;margin-right:10px;"
          >编辑</button>
          <el-popconfirm title="确认删除？" @confirm="deleteAddress(item)">
            <button class="common-btn-text common-btn-text-2" slot="reference">删除</button>
          </el-popconfirm>
        </div>
      </el-card>
    </div>
    <el-dialog class="address-modal" title="收货地址" :visible.sync="addressModal" width="600px">
      <el-form :model="addressData">
        <el-form-item label="省/市/区" :label-width="labelWidth">
          <el-cascader
            style="width: 100%"
            v-model="addressData.address"
            :options="area"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="省份" :label-width="labelWidth">
          <el-input v-model="addressData.receiverProvince"></el-input>
        </el-form-item>
        <el-form-item label="市" :label-width="labelWidth">
          <el-input v-model="addressData.receiverCity"></el-input>
        </el-form-item>
        <el-form-item label="区/县" :label-width="labelWidth">
          <el-input v-model="addressData.receiverDistrict"></el-input>
        </el-form-item>-->
        <el-form-item label="详细地址" :label-width="labelWidth">
          <el-input v-model="addressData.receiverAddress"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="labelWidth">
          <el-input v-model="addressData.receiverName"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="labelWidth">
          <el-input maxlength="11" v-model="addressData.receiverPhone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addressModal = false">取 消</el-button>
        <el-button type="primary" @click="addAddress">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import area from "../../js/china.json";
import {
  addressAdd,
  addressList,
  deleteReceiverAddress,
  modifyDefaultAddress,
  receiverAddressEdit
} from "@/js/api";
export default {
  name: "orderlist",
  computed: {},
  data() {
    return {
      area,
      query: {
        page: 0,
        pageSize: 10,
        orderStatus: this.$route.query.orderStatus || "",
        createTime: "",
        endTime: "",
        searchTime: []
      },
      total: 0,
      labelWidth: "120px",
      addressModal: false,
      editFlag: false,
      addressData: {
        address: [],
        receiverProvince: "",
        receiverCity: "",
        receiverDistrict: ""
      },
      addressList: []
    };
  },
  mounted() {
    this.getAddress();
  },
  methods: {
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getOrder();
    },
    handleCurrentChange(e) {
      this.query.page = e;
      this.getOrder();
    },
    handleChange(e) {
      this.addressData.receiverProvince = e[0];
      this.addressData.receiverCity = e[1];
      this.addressData.receiverDistrict = e[2];
    },
    getAddress() {
      addressList({
        userId: this.$store.state.user.info.id,
        pageSize: 99
      }).then(res => {
        if (res.code == 200) {
          const list = (res.result && res.result.records) || [];
          list.map(z => {
            z.address = [];
            z.address.push(z.receiverProvince);
            z.address.push(z.receiverCity);
            z.address.push(z.receiverDistrict);
          });
          this.addressList = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addAddress: function() {
      let req;
      if (this.editFlag) {
        req = receiverAddressEdit(this.addressData);
      } else {
        req = addressAdd(this.addressData);
      }
      req.then(res => {
        if (res.code == 200) {
          this.addressModal = false;
          this.$message.success(res.message);
          this.getAddress();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteAddress(item) {
      deleteReceiverAddress({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getAddress();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    modifyDefaultAddress(item) {
      modifyDefaultAddress({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getAddress();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  
</style>
